import { Link } from 'react-router-dom'
import { useTranslation } from '../i18n'

export function Guide() {
  const { t } = useTranslation()

  return (
    <div data-testid="guide-page" className="guide-page">
      <h1 className="page-title">{t('guide.title')}</h1>

      <div className="guide-content">
        <section className="guide-section">
          <h2>
            <i className="pi pi-info-circle" aria-hidden="true" />
            {t('guide.introduction')}
          </h2>
          <p>{t('guide.introText')}</p>
        </section>

        <section className="guide-section">
          <h2>
            <i className="pi pi-sitemap" aria-hidden="true" />
            {t('guide.coreConcepts')}
          </h2>

          <h3>{t('guide.projects')}</h3>
          <p>{t('guide.projectsDesc')}</p>

          <h3>{t('guide.testsAndAcceptance')}</h3>
          <p>{t('guide.testsAndAcceptanceDesc')}</p>
          <ul className="status-list">
            <li>
              <span className="status-badge status-passed">PASSED</span>
              {t('guide.statusPassedDesc')}
            </li>
            <li>
              <span className="status-badge status-failed">FAILED</span>
              {t('guide.statusFailedDesc')}
            </li>
            <li>
              <span className="status-badge status-skipped">SKIPPED</span>
              {t('guide.statusSkippedDesc')}
            </li>
            <li>
              <span className="status-badge status-error">ERROR</span>
              {t('guide.statusErrorDesc')}
            </li>
          </ul>

          <h3>{t('guide.featureCompletenessTitle')}</h3>
          <p>{t('guide.featureCompletenessDesc')}</p>
          <div className="formula-box">
            <code>{t('guide.featureCompletenessFormula')}</code>
          </div>
          <p>{t('guide.featureCompletenessNote')}</p>
        </section>

        <section className="guide-section">
          <h2>
            <i className="pi pi-sync" aria-hidden="true" />
            {t('guide.workflow')}
          </h2>

          <div className="workflow-steps">
            <div className="workflow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>{t('guide.step1Title')}</h4>
                <p>{t('guide.step1Desc')}</p>
                <code className="endpoint">POST /api/webhook</code>
              </div>
            </div>

            <div className="workflow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>{t('guide.step2Title')}</h4>
                <p>
                  {t('guide.step2Desc').split(t('nav.configuration'))[0]}
                  <Link to="/config">{t('nav.configuration')}</Link>
                  {t('guide.step2Desc').split(t('nav.configuration'))[1] ?? ''}
                </p>
              </div>
            </div>

            <div className="workflow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>{t('guide.step3Title')}</h4>
                <p>{t('guide.step3Desc')}</p>
              </div>
            </div>

            <div className="workflow-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4>{t('guide.step4Title')}</h4>
                <p>
                  {t('guide.step4Desc').split(t('page.projects'))[0]}
                  <Link to="/projects">{t('page.projects')}</Link>
                  {t('guide.step4Desc').split(t('page.projects'))[1] ?? ''}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="guide-section">
          <h2>
            <i className="pi pi-calculator" aria-hidden="true" />
            {t('guide.projectionFormulas')}
          </h2>

          <h3>{t('guide.avgHoursTitle')}</h3>
          <p>{t('guide.avgHoursDesc')}</p>
          <div className="formula-box">
            <code>{t('guide.avgHoursFormula')}</code>
          </div>
          <p className="formula-note">{t('guide.avgHoursNote')}</p>

          <h3>{t('guide.projectedTotalTitle')}</h3>
          <p>{t('guide.projectedTotalDesc')}</p>
          <div className="formula-box">
            <code>{t('guide.projectedTotalFormula')}</code>
          </div>
          <p className="formula-note">{t('guide.projectedTotalNote')}</p>

          <h3>{t('guide.endDateTitle')}</h3>
          <p>{t('guide.endDateDesc')}</p>
          <div className="formula-box">
            <code>{t('guide.dailyCapacityFormula')}</code>
            <br />
            <code>{t('guide.daysNeededFormula')}</code>
            <br />
            <code>{t('guide.endDateFormula')}</code>
          </div>
          <p className="formula-note">{t('guide.endDateNote')}</p>
        </section>

        <section className="guide-section">
          <h2>
            <i className="pi pi-link" aria-hidden="true" />
            {t('guide.quickLinks')}
          </h2>
          <div className="quick-links">
            <Link to="/" className="quick-link">
              <i className="pi pi-chart-bar" aria-hidden="true" />
              <span>{t('nav.dashboard')}</span>
              <small>{t('guide.viewTestTrends')}</small>
            </Link>
            <Link to="/failing" className="quick-link">
              <i className="pi pi-times-circle" aria-hidden="true" />
              <span>{t('nav.failingTests')}</span>
              <small>{t('guide.inspectFailures')}</small>
            </Link>
            <Link to="/projects" className="quick-link">
              <i className="pi pi-folder" aria-hidden="true" />
              <span>{t('nav.projects')}</span>
              <small>{t('guide.monitorCompletion')}</small>
            </Link>
            <Link to="/config" className="quick-link">
              <i className="pi pi-cog" aria-hidden="true" />
              <span>{t('nav.configuration')}</span>
              <small>{t('guide.manageProjects')}</small>
            </Link>
          </div>
        </section>
      </div>
    </div>
  )
}
